<template>
    <v-sheet color="transparent" class="containerAreaSheet" v-click-outside="{handler: onClickOutside}" @click="activeClick">
        <Chart :constructorType="'stockChart'" class="hc" :options="finalOptions" ref="chartRef" :class="isactive ? 'borderActive' : ''"></Chart>
        <v-sheet v-if="!isactive" class="areaChartSheet" ></v-sheet>
    </v-sheet>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted }    from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import {Chart} from 'highcharts-vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme } from 'vuetify';
const theme = useTheme();

/********************************
 *********** FUNCTION ***********
 *******************************/
import { getOptionsInGraphs } from '@/functions/project';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTGRAPHS          from '@/constants/graphs';

const props = defineProps({
    firstArray      : { required:true },
    secondArray     : { required:true },
    namePrimary     : { required:true },
    nameSecundary   : { required:true },
    colorFirst      : { required:true },
    colorSecond     : { required:true },
    title           : { required:true, type:String },
    subtitle        : { required:true, type:String },
    typeChart       : { required:true, type:String }
})


const potLine       = ref(CONSTGRAPHS.POTLINE[props.typeChart]);
const zones         = ref(CONSTGRAPHS.ZONES[props.typeChart]);
const colorText     = computed(() => theme.global.current.value.colors.colorText);
const yAxisTitle    = ref(CONSTGRAPHS.YAXISLABEL[props.typeChart] || '');

/* eslint-disable */

const finalSeries = ref( [
        {
            name: props.namePrimary,
            data: props.firstArray,
            color: props.colorFirst,
            zones: zones.value,
        },
        {
            name: props.nameSecundary,
            data: props.secondArray,
            color: props.colorSecond,
            zones: zones.value,
        }
])
const finalYAxis = ref({
        title: {
            text: yAxisTitle,
            style:{ color: colorText }
        },
        plotLines: [ {
            value: potLine,
            color: 'red',
            dashStyle: 'shortdash',
            width: 2,
            label: {
                text: props.typeChart == 'predict' ? '-75dBm' : '20dBm',
                style:{ color: colorText }
            }
        },
    ],
})

/**
 * getOptionsInGraphs(tipo, serie, titulo, subtitulo, ocultar leyenda, altura, tooltip, yaxis)
 */
const finalOptions:any = ref(getOptionsInGraphs('line',finalSeries.value,props.title, props.subtitle,false,550,{valueDecimals: 2},finalYAxis));

const chartRef = ref<any>();
const duplicateChart = ref();

const isactive = ref(false);

const onClickOutside = () => {
    isactive.value = false;
}

const activeClick = () =>{
    isactive.value = true;
}

onMounted(async () => {
    setTimeout(() => {
        duplicateChart.value = chartRef.value;
    }, 500);
});

onUnmounted(() => {
    if(duplicateChart.value){
        duplicateChart.value.chart.destroy();
    }
});
</script>